import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { http, apiError } from "@/lib/shop";

/** stock = { part, type: "in" | "out" } */
export const StockDialog = ({ stock, owner, onClose, onDone }) => {
  const [qty, setQty] = useState("1");
  const [note, setNote] = useState("");
  const [cost, setCost] = useState("");
  const [busy, setBusy] = useState(false);
  const adding = stock?.type === "in";

  useEffect(() => { if (stock) { setQty("1"); setNote(""); setCost(""); } }, [stock]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const body = { type: stock.type, quantity: parseInt(qty, 10), note: note || null };
      if (adding && owner && cost !== "") body.unit_cost = Number(cost);
      await http.post(`/parts/${stock.part.id}/movements`, body);
      toast.success(adding ? "Stock added" : "Stock removed");
      onDone();
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={!!stock} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-sm" data-testid="stock-dialog">
        <DialogHeader>
          <DialogTitle>{adding ? "Add stock" : "Remove stock"}</DialogTitle>
          <DialogDescription>{stock?.part.name} · {stock?.part.quantity} in stock now</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="grid gap-3">
          <div className="grid gap-1"><Label className="text-xs font-semibold">Quantity</Label><Input type="number" min="1" step="1" required value={qty} onChange={(e) => setQty(e.target.value)} data-testid="stock-qty-input" /></div>
          {adding && owner && <div className="grid gap-1"><Label className="text-xs font-semibold">Cost per part for this delivery (£, optional)</Label><Input type="number" min="0" step="0.01" value={cost} onChange={(e) => setCost(e.target.value)} data-testid="stock-cost-input" /></div>}
          <div className="grid gap-1"><Label className="text-xs font-semibold">Reason / note</Label><Input placeholder={adding ? "e.g. Delivery from supplier" : "e.g. Damaged, returned"} value={note} onChange={(e) => setNote(e.target.value)} data-testid="stock-note-input" /></div>
          <button disabled={busy} className={`rounded-full py-3 font-bold text-white disabled:opacity-60 ${adding ? "bg-emerald-600 hover:bg-emerald-700" : "bg-ink hover:bg-brand"}`} data-testid="stock-submit-btn">{adding ? "Add to stock" : "Remove from stock"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
